angular.module('internal.addevent-v2',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.addevent-v2', {
            url: '/addevent-v2/:prevState',
            views: {
                'content': {
                    templateUrl: 'js/internal/addevent-v2/addevent.view.html',
                    controller:'AddEventV2Ctrl'
                }
            }
        });
    }]);